<template>
    <div class="contact__stats__card">
        <h1>3</h1>
        <h2>Onbehandelde contacten</h2>
    </div>
</template>